(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SkipperLevelHolderDetailController', SkipperLevelHolderDetailController);

    SkipperLevelHolderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SkipperLevelHolder'];

    function SkipperLevelHolderDetailController($scope, $rootScope, $stateParams, previousState, entity, SkipperLevelHolder) {
        var vm = this;

        vm.skipperLevelHolder = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('askApp:skipperLevelHolderUpdate', function(event, result) {
            vm.skipperLevelHolder = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
